__turbopack_context__.v({
  "codeBlock": "U7qZGG_codeBlock",
  "metaBlock": "U7qZGG_metaBlock",
  "metaGrid": "U7qZGG_metaGrid",
  "metaLabel": "U7qZGG_metaLabel",
  "metaLeft": "U7qZGG_metaLeft",
  "metaOverview": "U7qZGG_metaOverview",
  "metaRight": "U7qZGG_metaRight",
  "metaSection": "U7qZGG_metaSection",
  "metaText": "U7qZGG_metaText",
  "metaTools": "U7qZGG_metaTools",
  "page": "U7qZGG_page",
});
